{{#each this}}
  <li class='teg-item'>
    <p>#{{this}}</p>
  </li>
{{/each}}